import React from 'react';
import useTextOverlayAdvancedAnimation from '../../../useTextOverlayAdvancedAnimation';
import AnimationColorSelector from '../../AnimationColorSelector';

export interface KaraokeAnimationWordFutureColorSelectorProps {}

const KaraokeAnimationWordFutureColorSelector: React.FC<KaraokeAnimationWordFutureColorSelectorProps> = () => {
  const {
    selectedAdvancedAnimation,
    onAnimationPropertyChange,
  } = useTextOverlayAdvancedAnimation();

  return (
    <AnimationColorSelector
      title="future word color"
      color={selectedAdvancedAnimation?.properties?.wordFutureColor}
      onChange={color => onAnimationPropertyChange('wordFutureColor', color)}
    />
  );
};

export default KaraokeAnimationWordFutureColorSelector;
